/*
 * @Author: chengyu
 * @Date: 2022-12-07 20:18:04
 * @Description: 服务埋点插件
 */
import { ServiceTypeEnum } from '../../enums';
import { MapApiEnum } from '../../enums/ubt';
import { isNetworkError } from '../../utils/is';
import { ubtMapApi } from '../../utils/ubt';
function getStatus(error, serviceType) {
    if (error) {
        if (serviceType === ServiceTypeEnum.HELLO)
            return MapApiEnum.lbsError;
        if (serviceType === ServiceTypeEnum.GAODE)
            return MapApiEnum.gaodeError;
    }
    else {
        if (serviceType === ServiceTypeEnum.HELLO)
            return MapApiEnum.lbsSuccess;
        if (serviceType === ServiceTypeEnum.GAODE)
            return MapApiEnum.gaodeSuccess;
    }
    return MapApiEnum.unknown;
}
function ubtPlugin(fetchOptions) {
    var context = fetchOptions.context, serviceType = fetchOptions.serviceType, method = fetchOptions.method;
    var startTime = new Date().getTime();
    // 逆地理编码，通过逆地理编码埋点记录
    if (method === 'reGeoCodingSearch')
        return {};
    if (!context.prevStartTime)
        context.prevStartTime = startTime;
    if (!context.prevServiceType)
        context.prevServiceType = serviceType;
    return {
        onSuccess: function (_, convertResponse, params) {
            ubtMapApi({
                fetchOptions: fetchOptions,
                context: context,
                params: params,
                response: convertResponse,
                startTime: startTime,
                error: null,
                status: getStatus(null, serviceType),
            });
        },
        onError: function (error, params) {
            ubtMapApi({
                fetchOptions: fetchOptions,
                context: context,
                params: params,
                error: error,
                startTime: startTime,
                response: isNetworkError(error) ? error.fetchData || {} : {},
                status: getStatus(error, serviceType),
            });
        },
    };
}
export default ubtPlugin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidWJ0UGx1Z2luLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvcmUvcmVxdWVzdC9wbHVnaW5zL3VidFBsdWdpbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBR0gsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLGFBQWEsQ0FBQztBQUM5QyxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFDN0MsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQ2hELE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUU1QyxTQUFTLFNBQVMsQ0FDaEIsS0FBbUIsRUFDbkIsV0FBNEI7SUFFNUIsSUFBSSxLQUFLLEVBQUU7UUFDVCxJQUFJLFdBQVcsS0FBSyxlQUFlLENBQUMsS0FBSztZQUFFLE9BQU8sVUFBVSxDQUFDLFFBQVEsQ0FBQztRQUN0RSxJQUFJLFdBQVcsS0FBSyxlQUFlLENBQUMsS0FBSztZQUFFLE9BQU8sVUFBVSxDQUFDLFVBQVUsQ0FBQztLQUN6RTtTQUFNO1FBQ0wsSUFBSSxXQUFXLEtBQUssZUFBZSxDQUFDLEtBQUs7WUFBRSxPQUFPLFVBQVUsQ0FBQyxVQUFVLENBQUM7UUFDeEUsSUFBSSxXQUFXLEtBQUssZUFBZSxDQUFDLEtBQUs7WUFBRSxPQUFPLFVBQVUsQ0FBQyxZQUFZLENBQUM7S0FDM0U7SUFFRCxPQUFPLFVBQVUsQ0FBQyxPQUFPLENBQUM7QUFDNUIsQ0FBQztBQUVELFNBQVMsU0FBUyxDQUFJLFlBQTBCO0lBQ3RDLElBQUEsT0FBTyxHQUEwQixZQUFZLFFBQXRDLEVBQUUsV0FBVyxHQUFhLFlBQVksWUFBekIsRUFBRSxNQUFNLEdBQUssWUFBWSxPQUFqQixDQUFrQjtJQUN0RCxJQUFNLFNBQVMsR0FBRyxJQUFJLElBQUksRUFBRSxDQUFDLE9BQU8sRUFBRSxDQUFDO0lBRXZDLG9CQUFvQjtJQUNwQixJQUFJLE1BQU0sS0FBSyxtQkFBbUI7UUFBRSxPQUFPLEVBQUUsQ0FBQztJQUU5QyxJQUFJLENBQUMsT0FBTyxDQUFDLGFBQWE7UUFBRSxPQUFPLENBQUMsYUFBYSxHQUFHLFNBQVMsQ0FBQztJQUM5RCxJQUFJLENBQUMsT0FBTyxDQUFDLGVBQWU7UUFBRSxPQUFPLENBQUMsZUFBZSxHQUFHLFdBQVcsQ0FBQztJQUVwRSxPQUFPO1FBQ0wsU0FBUyxFQUFFLFVBQUMsQ0FBQyxFQUFFLGVBQWUsRUFBRSxNQUFNO1lBQ3BDLFNBQVMsQ0FBQztnQkFDUixZQUFZLGNBQUE7Z0JBQ1osT0FBTyxTQUFBO2dCQUNQLE1BQU0sUUFBQTtnQkFDTixRQUFRLEVBQUUsZUFBZTtnQkFDekIsU0FBUyxXQUFBO2dCQUNULEtBQUssRUFBRSxJQUFJO2dCQUNYLE1BQU0sRUFBRSxTQUFTLENBQUMsSUFBSSxFQUFFLFdBQVcsQ0FBQzthQUNyQyxDQUFDLENBQUM7UUFDTCxDQUFDO1FBQ0QsT0FBTyxFQUFFLFVBQUMsS0FBSyxFQUFFLE1BQU07WUFDckIsU0FBUyxDQUFDO2dCQUNSLFlBQVksY0FBQTtnQkFDWixPQUFPLFNBQUE7Z0JBQ1AsTUFBTSxRQUFBO2dCQUNOLEtBQUssT0FBQTtnQkFDTCxTQUFTLFdBQUE7Z0JBQ1QsUUFBUSxFQUFFLGNBQWMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLFNBQVMsSUFBSSxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUU7Z0JBQzVELE1BQU0sRUFBRSxTQUFTLENBQUMsS0FBSyxFQUFFLFdBQVcsQ0FBQzthQUN0QyxDQUFDLENBQUM7UUFDTCxDQUFDO0tBQ0YsQ0FBQztBQUNKLENBQUM7QUFFRCxlQUFlLFNBQVMsQ0FBQyJ9